import $ from 'jquery';
import disclaimers from 'components/disclaimers';

var localDisclaimers = {
  load: function (el) {
    this.$scope = $(el);
    $(document).ready(function () {
      disclaimers.addLocalDisclaimers();
    });
  }
};

export default localDisclaimers;
